<template>
  <div class="certificate-vaccine pb-1">
    <div class="logos-wrapper">
      <img :src="require('@/assets/images/Coat_of_arms_of_Aruba-lines.svg')" />
    </div>

    <div v-if="data">
      <h2 v-if="shaIsZero">
        <span class="badge rounded-pill bg-danger badge-custom px-5 py-4 mb-3 mt-5"> This certificate has been rejected </span>
      </h2>
      <h2 v-else>
        <span class="badge rounded-pill bg-success badge-custom px-5 py-4 mb-3 mt-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check-circle-fill me-2" viewBox="0 0 16 16">
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
            />
          </svg>
          Certificate successfully validated
        </span>
      </h2>

      <div class="card" style="max-width: 400px">
        <div class="card-header" style="text-align: left; padding: 14px 20px; text-transform: uppercase; font-weight: 600; color: gray">
          Certificate Info
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <span class="key">Certificate ID:</span>
            <span class="value">{{ data.certificationRecordId }}</span>
          </li>
          <li class="list-group-item">
            <span class="key">Certificate Date:</span>
            <span class="value" v-html="formatDate(data.certificationDate)"></span>
          </li>
          <li class="list-group-item">
            <span class="key">
              Birthday: <span class="verify-birthday bg-danger"> <i class="fas fa-exclamation-circle"></i> Verify birthday with subject</span>
            </span>
            <span class="value" style="clear: both">{{ formatDate(data.patientBirthDay) }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <h2>
        <span class="badge rounded-pill bg-danger px-5 py-4 mb-3 mt-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check-circle-fill me-2" viewBox="0 0 16 16">
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
            />
          </svg>
          Certificate not valid
        </span>
      </h2>
    </div>

    <div class="contact-info-wrapper mb-5">
      <div>Department of Public Health (DVG)</div>
      <div>Address: Caya Ing. R.H. Lacle 4, Oranjestad, Aruba - Phone: (297) 522-4200. Fax: (297) 582-6436</div>
    </div>
    <!-- <div class="footer">
      <img width="200" :src="require('@/assets/images/logo-dvg.svg')" />
      <img width="150" :src="require('@/assets/images/logo-ata.svg')" />
    </div> -->
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: ['data', 'shaIsZero'],
  data() {
    return {};
  },
  created() {},
  methods: {
    formatDate(d) {
      console.log(d);
      return moment(d, 'YYYY-MM-DD').format('DD-MMM-YYYY');
    },
  },
};
</script>

<style lang="scss">
.certificate-vaccine {
  .logos-wrapper {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    height: 175px;
    img {
      max-width: 200px;
      width: 100%;
      margin: 0 auto;
    }
  }
  .card {
    margin: 20px auto;
    .list-group-item {
      border-top: 1px solid rgba(0, 0, 0, 0.125) !important;
      text-align: left;
      padding: 14px 20px;
      font-weight: 500;
      span {
        display: block;
      }
      span.key {
        font-weight: 400;
        color: grey;
      }
      span.value {
      }
    }
    .verify-birthday {
      float: right;
      font-size: 0.8rem;
      padding: 2px 8px;
      font-weight: 600;
      border-radius: 30px;
    }
  }
  .contact-info-wrapper {
    font-size: 18px;
    padding: 20px;
    margin: 40px auto;
    border-radius: 14px;

    span {
      text-transform: uppercase;
      //font-weight: 600;
      color: grey;
      font-size: 13px;
    }
  }

  .footer {
    display: flex;
    justify-content: space-evenly;
    img {
      max-width: 200px;
    }
  }
}

/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  .certificate-vaccine {
    .logos-wrapper {
      height: 130px;
      img {
        max-width: 140px;
      }
    }
    .card {
      .list-group-item {
        display: block;
        //justify-content: space-between;
      }
    }
    .badge-custom {
      display: block;
      padding: 10px !important;
      font-size: 14px;
    }

    .contact-info-wrapper {
      font-size: 16px;
      span {
        display: block;
      }
    }
  }
}
</style>